import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = { class: "menu-content pt-8 pb-2" }
const _hoisted_4 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_5 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_6 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_7 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_8 = { class: "menu-title" }
const _hoisted_9 = { class: "menu-link" }
const _hoisted_10 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_11 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_12 = { class: "menu-title" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_15 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_16 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_17 = { class: "menu-title" }
const _hoisted_18 = {
  key: 1,
  class: "menu-badge"
}
const _hoisted_19 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_20 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_21 = { class: "menu-link" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_23 = { class: "menu-title" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_27 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (item.heading && _ctx.checkSubMenuPermission(item.pages[0]))
            ? (_openBlock(), _createElementBlock("div", {
                class: "menu-item",
                key: i
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate(item.heading)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
              (menuItem.heading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.checkMainMenuPermission(menuItem.allowedPermission))
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: _normalizeClass(["menu-link", { active: _ctx.hasActiveChildren(menuItem.route) }]),
                          "active-class": "active",
                          to: menuItem.route
                        }, {
                          default: _withCtx(() => [
                            (menuItem.svgIcon || menuItem.fontIcon)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                  (_ctx.asideMenuIcons === 'font')
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                      }, null, 2))
                                    : (_ctx.asideMenuIcons === 'svg')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                          _createVNode(_component_inline_svg, {
                                            src: menuItem.svgIcon
                                          }, null, 8, ["src"])
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "to"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (menuItem.sectionTitle && _ctx.checkSubMenuPermission(menuItem))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([{ show: menuItem.sectionKey==_ctx.route.meta.section }, "menu-item menu-accordion"]),
                    "data-kt-menu-sub": "accordion",
                    "data-kt-menu-trigger": "click"
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      (menuItem.svgIcon || menuItem.fontIcon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            (_ctx.asideMenuIcons === 'font')
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                }, null, 2))
                              : (_ctx.asideMenuIcons === 'svg')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                    _createVNode(_component_inline_svg, {
                                      src: menuItem.svgIcon
                                    }, null, 8, ["src"])
                                  ]))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                      _hoisted_13
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                          (item2.heading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_ctx.checkMainMenuPermission(item2.allowedPermission))
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: _normalizeClass(["menu-link", { active: _ctx.hasActiveChildren(item2.route) }]),
                                      "exact-active-class": "active",
                                      to: item2.route
                                    }, {
                                      default: _withCtx(() => [
                                        (item2.svgIcon || item2.fontIcon)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                              (_ctx.asideMenuIcons === 'font')
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass([item2.fontIcon, "bi fs-3"])
                                                  }, null, 2))
                                                : (_ctx.asideMenuIcons === 'svg')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                                      _createVNode(_component_inline_svg, {
                                                        src: item2.svgIcon
                                                      }, null, 8, ["src"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate(item2.heading)), 1),
                                        (item2.badge)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                              (item2.heading == 'Pending Orders' && _ctx.pendingOrders > 0)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.pendingOrders), 1))
                                                : (item2.heading == 'Pending Order Products' && _ctx.pendingOrderProducts > 0)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.pendingOrderProducts), 1))
                                                  : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["class", "to"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (item2.sectionTitle)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"]),
                                "data-kt-menu-sub": "accordion",
                                "data-kt-menu-trigger": "click"
                              }, [
                                _createElementVNode("span", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                  _hoisted_24
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                      (item3.heading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                            _createVNode(_component_router_link, {
                                              class: "menu-link",
                                              "active-class": "active",
                                              to: item3.route
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_26,
                                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ], 2)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 2)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 256))
    ])
  ], 512))
}